module.exports = __webpack_public_path__ + "static/img/goods-main-img01.14ff93ef.svg";